class GridLayoutSwitcher extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', this.handleOnChange.bind(this));

    // get from local storage
    const gridType = localStorage.getItem('gridType');
    if (gridType) {
      this.querySelector(`input[value="${gridType}"]`).checked = true;
    } else {
      localStorage.setItem('gridType', 'small');
    }
  }

  handleOnChange(event) {
    const gridType = event.target.value;

    // Update the grid type
    document.documentElement.dataset.gridType = gridType;

    // store to local storage
    localStorage.setItem('gridType', gridType);
  }
}

customElements.define('grid-layout-switcher', GridLayoutSwitcher);